import { makeStyles } from "@material-ui/core";

export const billingV2Styles = makeStyles((theme) => ({
  headerWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px",
    backgroundColor: "#fff",
    borderRadius: 8,
  },

  contentWrapper: {
    paddingTop: '12px'
  },

  currentSubscriptionWrapper: {
    backgroundColor: "#fff",
    padding: 16,
    borderRadius: 8,
    marginBottom: 16,
    "& .headerSection": {
      display: "flex",
      justifyContent: "space-between",
    },

    "& .headerLeft": {
      "& .title": {
        margin: "0 0 4px 0",
        color: "#001d35",
      },
    },

    "& .headerRight": {
      display: "flex",
      alignItems: "flex-end",
      gap: 4,

      "& .perMonth": {
        fontSize: 14,
        fontWeight: 600,
        color: "#4c535d",
        marginBottom: 8,
      },
    },

    "& .billingDate": {
      color: "#3a414a",
      fontSize: 14,
      fontWeight: 600,
      marginTop: 24,
    },
  },

  paymentMethodWrapper: {
    backgroundColor: "#fff",
    borderRadius: 8,
    marginBottom: 16,

    "& .headerSection": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      borderBottom: "1px solid #f0f0f0",
      padding: 16,

      "& .title": {
        margin: "0 0 4px 0",
        color: "#001d35",
      },
      

    },

    "& .cardSection": {
      display: "flex",
      alignItems: "center",
      gap: 24,
      padding: 16,

      "& .cardLogo":{
        "& .logo":{
          // height: 40,
          // padding: 16,
          // backgroundColor: "#f0f0f0",
          // borderRadius: 8,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          '& .MuiSvgIcon-root': {
            fill: 'rgb(62, 80, 247)',
            fontSize: '30px'
          }
        }
      },
      "& .cardDetails":{
        "& .cardNumber":{},
        "& .cardExpireDate":{
          color: "#4c535d",
          fontSize: 14,
          fontWeight: 300
        }
      },
      "& .cardStatus":{
        color: "#366AED",
        fontSize: 12,
        padding: "4px 16px",
        backgroundColor: "#F0F6FF",
        borderRadius: 50,
      }
    }
  },
  creditBalanceWrapper: {
    backgroundColor: "#fff",
    borderRadius: 8,
    marginBottom: 16,

    "& .headerSection": {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      borderBottom: "1px solid #f0f0f0",
      padding: 16,

      "& .title": {
        margin: "0 0 4px 0",
        color: "#001d35",
      },

      "& .addMoreButton":{
        backgroundColor: "#3e50f7",
        color: "#fff",
        textTransform: "capitalize",
        "&:focus, &:hover":{
          backgroundColor: "#3e50f7",
        }
      },

      "& .buttonOutlined": {
        backgroundColor: "#fff",
        color: "#3e50f7",
        borderColor: "#3e50f7",
        textTransform: "capitalize",
        "&:focus, &:hover":{
          backgroundColor: "#fff",
        }
      }

      

    },

    "& .autoRechargeWrapper": {
      position: 'relative',
      "& .headerSection": {
          alignItems: "center",
          borderBottom: "none",

        "& .title": {

        },
      },

      '& .updateAutoRechargeButton': {
        position: "absolute",
        right: "555px",
        top: "160px",
        backgroundColor: "#3e50f7",
        color: "#fff",
        textTransform: "capitalize",
        "&:focus, &:hover":{
          backgroundColor: "#3e50f7",
        },
        '&:disabled': {
          backgroundColor: "rgba(62,80,247,0.33)",
        }
      }
    }
  },
  notesList: {
    fontSize: 14,
    width: "100%",
    paddingLeft: theme.spacing(2.25),
    "& li": {
      listStyleType: "disc !important",
    },
    "& svg.MuiSvgIcon-root": {
      color: "#2196f3 !important",
    },
  },
  button: {
    padding: "8px 30px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },

  closeButton: {
    backgroundColor: "#ffffff",
    border: "2px solid #d9dce0",
    color: "#333",
    fontSize: "16px",
    "&:focus, &:hover": {
      backgroundColor: "#f6f6f6",
    },
  },

  confirmButton: {
    backgroundColor: "#3e50f7",
    color: "#fff",
    border: "2px solid #3e50f7",
    "&:focus, &:hover": {
      border: "2px solid #3e50f7",
      backgroundColor: "#3e50f7",
      transform: "translateY(-1px)",
    },
  },

  disabled: {
    opacity: 0.5,
    cursor: "not-allowed",
    pointerEvents: "none",
  },

  sortButton: {
    "&:hover": {
      backgroundColor: "#f2ece3",
    },
  },

  cancelButton: {
    background: "#E81E10 !important",
    fontWeight: "600",
  },
  noPaymentMethod: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
    gap: "20px",
    paddingTop: "20px",
    paddingBottom: "20px",

    "& .addMoreButton":{
      backgroundColor: "#3e50f7",
      color: "#fff",
      textTransform: "capitalize",
      "&:focus, &:hover":{
        backgroundColor: "#3e50f7",
      }
    },
  },
  brandIcon: {
    width: "51px",
    height: "38px",
    backgroundImage: `url(${process.env.REACT_APP_CDN_LINK}assets/images/releases/1.0.0/top-card-brand-icons.png)`,
    backgroundPosition: "-202px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "500px"
  }
}));

export const tabsStyles = makeStyles((theme) => ({
  tabs: {
    "& .MuiTabs-indicator": {
      backgroundColor: "var(--light_blue)",
    },
  },
  tab: {
    fontSize: "15px !important",
    color: "var(--dark_blue)",
    fontWeight: 500,
    textTransform: "capitalize",
    "&:focus": {
      color: "var(--dark_blue)",
      backgroundColor: "transparent",
    },
    "&:hover": {
      color: "var(--light_blue)",
      backgroundColor: "transparent",
    },
    "&.Mui-selected": {
      color: "var(--light_blue)",
      backgroundColor: "transparent",
    },
  },
  filterDesign: {
    minWidth: "185px !important",
    justifyContent: "space-between",
    gap: "12px !important",
  },
}));
